import {
  serializeForm,
  logForNewRelic,
  createPanelToggle
} from './../utilities';
import { form } from 'formifier';
import fetchJsonp from 'fetch-jsonp';

const firstNameMessages = {
    valueMissing: 'Please enter a first name.'
  },
  lastNameMessages = {
    valueMissing: 'Please enter a last name.'
  },
  emailMessages = {
    valueMissing: 'Please enter an email address.',
    patternMismatch:
      "It looks like that's not an actual email address. Double check and try again.",
    typeMismatch:
      "It looks like that's not an actual email address. Double check and try again."
  },
  phoneMessages = {
    valueMissing: 'Please enter a phone number.',
    patternMismatch:
      "It looks like that's not an actual phone number. Double check and try again.",
    typeMismatch:
      "It looks like that's not an actual phone number. Double check and try again."
  };

const showErrors = (responseData, formElement) => {
  formElement.setAttribute('data-analytics-form-submission-status', 'failure');
  formElement.firstChild.insertAdjacentHTML(
    'beforebegin',
    `<p class="Alert">${responseData}</p>`
  );
  const submitButton = formElement.querySelector('[type="submit"]');
  submitButton.removeAttribute('disabled');
  submitButton.classList.remove('is-active');
  submitButton.textContent = submitButton.getAttribute('data-enable-with');
};
const submitHandler = (formElement) => {
  const errorMessage = formElement.querySelector('.Alert');
  formElement.dispatchEvent(
    new CustomEvent('parsleySubmit', { bubbles: true, cancelable: true })
  );

  if (errorMessage) {
    errorMessage.parentNode.removeChild(errorMessage);
  }

  const formObj = serializeForm(formElement),
    actionURL = formElement.getAttribute('action'),
    fullPath = actionURL.concat('?', formObj);

  fetchJsonp(fullPath, {
    jsonpCallbackFunction: 'callback'
  })
    .then((response) => response.json())
    .then((responseData) => {
      if (responseData.error) {
        showErrors(responseData.error, formElement);
        return;
      }

      formElement.outerHTML = `<div class="ModalPanel-body" data-analytics-form-submission="success" data-analytics-form-completed-id="${responseData.id}">
    <h3 class="ModalPanel-notification">${responseData.message}</h3>
    <p>${responseData.description}</p>
    </div>`;
    })
    .catch((error) => {
      logForNewRelic(error, { fullPath });
      showErrors(error, formElement);
    });
};

const contactSubmitHandler = (formElement) => {
  const options = {
      method: formElement.getAttribute('method'),
      headers: { Accept: 'application/json' },
      body: new FormData(formElement)
    },
    errorMessage = formElement.querySelector('.Alert');
  formElement.dispatchEvent(
    new CustomEvent('parsleySubmit', { bubbles: true, cancelable: true })
  );

  if (errorMessage) {
    errorMessage.parentNode.removeChild(errorMessage);
  }

  fetch(formElement.getAttribute('action'), options)
    .then((response) => response.json())
    .then((responseData) => {
      if (responseData.error) {
        showErrors(responseData.error, formElement);
        return;
      }

      formElement.outerHTML = `<div class="ModalPanel-body" data-analytics-form-submission="success" data-analytics-form-completed-id="${responseData.id}">
      <h3 class="ModalPanel-notification">${responseData.message}</h3>
      <p>${responseData.description}</p>
      </div>`;
    })
    .catch((error) => {
      showErrors(error, formElement);
    });
};

const initializeForms = () => {
  const leadForm = document.getElementById('lead_form');

  if (!leadForm) {
    return;
  }

  createPanelToggle(
    'lead_form_modal',
    '.js-leadFormTrigger, #close_lead_form',
    'is-open'
  );
  form(
    {
      'general_lead[first_name]': firstNameMessages,
      'general_lead[last_name]': lastNameMessages,
      'general_lead[email]': emailMessages,
      'general_lead[phone]': phoneMessages,
      'general_lead[description]': {}
    },
    leadForm,
    submitHandler
  );

  createPanelToggle(
    'contact_form_modal',
    '.js-contactFormTrigger, #close_contact_form',
    'is-open'
  );
  form(
    {
      'contact[first_name]': firstNameMessages,
      'contact[last_name]': lastNameMessages,
      'contact[email]': emailMessages,
      'contact[phone]': phoneMessages,
      'contact[message]': {
        valueMissing: 'Please enter a message.'
      }
    },
    document.getElementById('contact_form'),
    contactSubmitHandler
  );
};
export default initializeForms;
